import React from "react";
import pareja2 from "../assets/pareja2.png";

const SecondaryBanner = ({
  bgColor = "#0346a4",
  image,
  text = "Obtén los mejores rendimientos en el corto y largo plazo.",
  highlightText = "Laura y Andrés hicieron realidad su sueño de tener casa propia ahorrando con Meu Aliado.",
}) => {
  const bannerImage = image || pareja2;
  return (
    <section className="w-full" style={{ backgroundColor: bgColor }}>
      <div className="flex flex-col md:flex-row w-full text-white">
        <div className="w-full md:w-1/2 relative flex justify-center items-center overflow-hidden">
          <img
            src={bannerImage}
            alt="Historias Meu Aliado"
            className="object-cover w-full h-72 sm:h-96 md:h-full"
          />
          <p className="text-[#e8f2f4] bg-[#02285c]/80 md:bg-transparent px-6 py-4 text-sm sm:text-base md:text-lg md:max-w-xs md:absolute md:bottom-8 md:left-8">
            {highlightText}
          </p>
        </div>
        <div className="w-full md:w-1/2 flex justify-center items-center px-6 sm:px-10 py-10">
          <p className="text-white font-bold text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight max-w-2xl">
            {text}
          </p>
        </div>
      </div>
    </section>
  );
};

export default SecondaryBanner;
